<div class="container">
  <div class="panel">
    <div class="payment-cancelled-wrapper">
      <h1 class="heading-primary">You have cancelled the payment</h1>
      <div class="icon">
        <svg xmlns="http://www.w3.org/2000/svg" width="102" height="102" viewBox="0 0 102 102" fill="none">
          <path fill-rule="evenodd" clip-rule="evenodd"
            d="M0.556396 50.9999C0.556396 78.8591 23.1407 101.443 50.9999 101.443C78.8591 101.443 101.443 78.8591 101.443 50.9999C101.443 23.1407 78.8591 0.556396 50.9999 0.556396C23.1407 0.556396 0.556396 23.1407 0.556396 50.9999ZM98.9435 50.9999C98.9435 77.4784 77.4784 98.9435 50.9999 98.9435C24.5215 98.9435 3.0564 77.4784 3.0564 50.9999C3.0564 24.5215 24.5215 3.0564 50.9999 3.0564C77.4784 3.0564 98.9435 24.5215 98.9435 50.9999ZM30.0724 31.0337C29.5842 30.5455 29.5842 29.7541 30.0724 29.2659C30.5605 28.7778 31.352 28.7778 31.8401 29.2659L52.2096 49.6354L72.5791 29.2659C73.0673 28.7778 73.8587 28.7778 74.3469 29.2659C74.835 29.7541 74.835 30.5455 74.3469 31.0337L53.9774 51.4032L74.3469 71.7727C74.835 72.2608 74.835 73.0523 74.3469 73.5404C73.8587 74.0286 73.0673 74.0286 72.5791 73.5404L52.2096 53.1709L31.8401 73.5404C31.352 74.0286 30.5605 74.0286 30.0724 73.5404C29.5842 73.0523 29.5842 72.2608 30.0724 71.7727L50.4419 51.4032L30.0724 31.0337Z"
            fill="#0A4793" />
        </svg>
      </div>
      <p class="paragraph">You can restart the payment at the merchant.</p>
      <button class="btn btn-primary btn-block" (click)="closePayment()">Close</button>
    </div>
  </div>
</div>


